export default "__VITE_ASSET__9LOIsa1n__"